module.exports = __webpack_public_path__ + "img/dollar-outline-blue.2fe9e5f8.svg";